import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useStore } from 'vuex';
	import { IStoreState, IVehicle } from '@/types.d';
	import { ECtas, EStockCategoryId } from '@/enums';

	
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

	// import { computed } from 'vue';
	const store = useStore<IStoreState>();
	const vehicle: IVehicle = (window as any).uvDetailPageVehicle;

	const handleEnquireClick = async ($event: Event) => {
		$event.preventDefault();
		const dataLayer = (window as any).dataLayer || [];

		if (vehicle.Vin || vehicle.StockIdentifier){
			let condition = '';
			switch (vehicle.StockCategoryId){
				case EStockCategoryId.new: {
					condition = 'New';
					break;
				}
				case EStockCategoryId.used: {
					condition = 'Used';
					break;
				}
				case EStockCategoryId.demo: {
					condition = 'Demo';
					break;
				}
			}
			dataLayer.push({
				'eventCategory':'Site Actions',
				'eventAction':`Enquire Now - ${condition} Vehicle`,
				'eventLabel':`${vehicle.ManuYear ? vehicle.ManuYear : ''} ${vehicle.Make} ${vehicle.Model} ${vehicle.Grade} (${vehicle.Rego})`
			});
			store.commit('setEnquiryModal', {
				isVisible: true, 
				type: ECtas.enquireButton, 
				vehicle: vehicle
			});
		}
		else {
			console.log('error getting vehicle.');
		}
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "button-brand test",
    onClick: handleEnquireClick
  }, "Enquire Now"))
}
}

})